import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d1929d5")

_pushScopeId("data-v-5d1929d5")
const _hoisted_1 = { class: "card__header" }
const _hoisted_2 = { class: "status" }
const _hoisted_3 = { class: "card__main" }
const _hoisted_4 = { class: "card__info" }
const _hoisted_5 = { class: "card__doctor" }
const _hoisted_6 = { class: "sub -medium" }
const _hoisted_7 = { class: "main -bold" }
const _hoisted_8 = { class: "card__insertDate" }
const _hoisted_9 = { class: "main -bold" }
const _hoisted_10 = { class: "sub -medium" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "-vector" }, null, -1)
const _hoisted_12 = { class: "card__scheduleDate" }
const _hoisted_13 = { class: "sub -medium" }
const _hoisted_14 = { class: "main -bold" }
const _hoisted_15 = { class: "card__footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RequestProgress = _resolveComponent("RequestProgress")
  const _component_router_link = _resolveComponent("router-link")
  const _component_RequestProgressDesc = _resolveComponent("RequestProgressDesc")

  return (_openBlock(), _createBlock("div", {
    class: ["request-card", _ctx.cardInfo.style]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_RequestProgress, { cardInfo: _ctx.cardInfo }, null, 8, ["cardInfo"]),
        (_ctx.isOnlineCare)
          ? (_openBlock(), _createBlock(_component_RequestProgress, {
              key: 0,
              cardInfo: _ctx.appointInfo
            }, null, 8, ["cardInfo"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_router_link, {
        to: _ctx.view,
        class: "detail -medium"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("show detail")), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, _toDisplayString(_ctx.state.item.DocFacilityName) + " " + _toDisplayString(_ctx.state.item.DesiredDrDeptName), 1),
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.state.item.DesiredDrName), 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, [
            _createVNode(_component_RequestProgressDesc, { cardInfo: _ctx.cardInfo }, null, 8, ["cardInfo"])
          ]),
          _createVNode("span", _hoisted_10, _toDisplayString(_ctx.insertDateTime), 1)
        ])
      ]),
      (_ctx.state.kind === _ctx.RequestKindTypes.OnlineCare)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _hoisted_11,
            _createVNode("div", null, [
              _createVNode("div", _hoisted_12, [
                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.t("scheduled date/time")), 1),
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.ScheduledDateTime), 1)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_15, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cardInfo.buttons, (b, index) => {
        return (_openBlock(), _createBlock(_Fragment, { key: index }, [
          (b.type === 'link')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: ["-button", b.style],
                to: !!b.path ? b.path() : ''
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(b.label), 1)
                ]),
                _: 2
              }, 1032, ["to", "class"]))
            : _createCommentVNode("", true),
          (b.type === 'button')
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                class: ["-button", b.style],
                onClick: b.func
              }, _toDisplayString(b.label), 11, ["onClick"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ], 2))
})